import React from "react";
import { BarChart4, Compass, Lightbulb, RefreshCcw, Target } from "lucide-react";

import { Hero, FeaturesGrid, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";
import { services } from "../content/services";

function BRP() {
  const service = services.find((s) => s.id === "bpr");

  return (
    <div>
      <Seo title="Business Process Re-engineering" description={service.description} />
      <Hero
        eyebrow="Service"
        title="Business Process Re-engineering (BPR)"
        subtitle={service.description}
        primaryCta={{ label: "Book a consultation", to: "/Contact" }}
        secondaryCta={{ label: "See software services", to: "/SoftwareDevelopment" }}
        imageSrc={service.heroSrc}
        imageAlt="Business process re-engineering"
        highlights={service.highlights}
      />

      <FeaturesGrid
        eyebrow="How we help"
        title="Unlock efficiency through process redesign."
        subtitle="A structured approach to discover bottlenecks, improve throughput, and keep teams aligned."
        columns={3}
        features={[
          { title: "Discovery & mapping", description: "Document current processes and identify friction points.", icon: Compass },
          { title: "Redesign", description: "Create streamlined workflows aligned to your goals.", icon: RefreshCcw },
          { title: "Innovation enablement", description: "Introduce tools and practices that improve execution.", icon: Lightbulb },
          { title: "Measurable outcomes", description: "Define KPIs and track improvement over time.", icon: Target },
          { title: "Better visibility", description: "Improve transparency across operations and handoffs.", icon: BarChart4 },
        ]}
      />

      <CTASection
        title="Want to improve operational performance?"
        subtitle="We’ll help you redesign workflows and support adoption across teams."
        primaryCta={{ label: "Contact us", to: "/Contact" }}
        secondaryCta={{ label: "Explore ERP", to: "/EasyBooks_ERP" }}
      />
    </div>
  );
}

export default BRP;